// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.off-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
  backdrop-filter: blur(8px);
}

.off-modal-content {
  background-color: #0e1b1b;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  width: 90%;
  max-width: 460px;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
  animation: modalScaleUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes modalScaleUp {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.off-modal-title {
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 800;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 12px;
}

.off-modal-body {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 28px;
}

.off-modal-body strong {
  color: #fff;
  font-weight: 600;
}

.off-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.off-modal-btn {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 30px;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  min-height: 40px;
}

.off-modal-btn--ghost {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.85);
}

.off-modal-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
}

.off-modal-btn--danger {
  background-color: #b32b2b;
  border: none;
  color: #ffffff;
}

.off-modal-btn--danger:hover {
  background-color: #d13b3b;
  box-shadow: 0 4px 12px rgba(209, 59, 59, 0.3);
}

.off-modal-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: modalSpin 0.8s linear infinite;
  display: inline-block;
}

@keyframes modalSpin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Offerings/DeleteConfirmationModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".off-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 11000;\n  backdrop-filter: blur(8px);\n}\n\n.off-modal-content {\n  background-color: #0e1b1b;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  width: 90%;\n  max-width: 460px;\n  padding: 32px;\n  box-sizing: border-box;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);\n  animation: modalScaleUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes modalScaleUp {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.off-modal-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\n.off-modal-body {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.72);\n  margin-bottom: 28px;\n}\n\n.off-modal-body strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n.off-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.off-modal-btn {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 10px 24px;\n  border-radius: 30px;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease;\n  min-height: 40px;\n}\n\n.off-modal-btn--ghost {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.off-modal-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.35);\n  color: #fff;\n}\n\n.off-modal-btn--danger {\n  background-color: #b32b2b;\n  border: none;\n  color: #ffffff;\n}\n\n.off-modal-btn--danger:hover {\n  background-color: #d13b3b;\n  box-shadow: 0 4px 12px rgba(209, 59, 59, 0.3);\n}\n\n.off-modal-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: modalSpin 0.8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes modalSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
